import { motion } from 'framer-motion';
import { styled } from 'styled-components';

import { accordionTransition, AccordionVariant, accordionVertical } from '@pkg/motion';
import { CommonAction, recipesCommonAction, styledTypography } from '@pkg/primitives';

import { tokens } from './FiltersReport.tokens.ts';

export const Report = styled(motion.div).attrs({
    variants: accordionVertical,
    initial: AccordionVariant.Hidden,
    animate: AccordionVariant.Show,
    exit: AccordionVariant.Hidden,
    transition: accordionTransition,
})`
    overflow: hidden;
`;

// The interior spacing is needed so that we can avoid a
// sudden gap change when this accordion mounts/unmounts.
// Ideally, we can conditionally apply this and even specify
// the exact values needed.
export const Interior = styled.div`
    padding-top: ${tokens.interior.spaceBefore}px;
    padding-bottom: ${tokens.interior.spaceAfter}px;
`;

export const Content = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: ${tokens.content.gap}px;
`;

export const Label = styled.p`
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};
    font-size: ${tokens.label.size.mobile}px;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
    letter-spacing: -0.02em;
    color: rgb(255, 255, 255, 0.5);
    white-space: nowrap;

    @media (min-width: 768px) {
        font-size: ${tokens.label.size.desktop}px;
    }
`;

export const ClearAction = styled(CommonAction)`
    ${recipesCommonAction.basic};
    padding: ${tokens.clearAction.padding}px;
    text-decoration: underline 1px currentColor;
    color: rgb(255, 255, 255, 0.6);

    &:disabled {
        opacity: 0.8;
    }

    &:hover:not(:active) {
        color: rgb(255, 255, 255, 0.8);
    }
`;

export const ClearActionLabel = styled.span`
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};
    display: block;
    font-size: ${tokens.clearAction.fontSize}px;
    letter-spacing: -0.02em;
    color: currentColor;
`;
